import { DeleteIcon } from "common/components/icon";
import { DefaultButton } from "./DefaultButton";

export const ImagePreview = ({
  width,
  height,
  borderColor,
  src,
  onClick,
  showDeleteButton,
  onDelete,
  children,
}) => {
  return (
    <DefaultButton
      style={{ position: "relative" }}
      width={width}
      height={height}
      borderColor={borderColor}
      src={src}
      onClick={onClick}>
      {showDeleteButton && (
        <DeleteIcon
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            margin: "0.5rem",
          }}
          onClick={onDelete}
        />
      )}
      {children}
    </DefaultButton>
  );
};
